import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate, useParams } from 'react-router'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import { setViewSeminarLesson, toggleFormSeminarLesson } from '../../../../../redux/actions/seminarlessons'
import { showSeminar, toggleFormSeminar } from '../../../../../redux/actions/seminars'
import { IRootState } from '../../../../../redux/types'
import useBooleanState from '../../../../shared/hooks/useBooleanState'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'
import useUserDisplaytime from '../../../../shared/hooks/useUserDisplaytime'

export const useSeminarDetail = () => {
  const dispatch = useDispatch()
  const { pathname, search } = useLocation()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const searchParams = new URLSearchParams(search)

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { seminarSelected, showForm, error, msg, loading } = useSelector((state: IRootState) => state.seminar)
  const {
    seminarlesson_selected,
    showForm: showFormSeminarLesson,
    registeredUsers
  } = useSelector((state: IRootState) => state.seminarlesson)

  const [open, setOpen] = useBooleanState(false)
  const [favoriteState, setFavoriteState] = useState<boolean>(false)
  const [currentTab, setCurrentTab] = useState(0)

  const { handleViewGeneralSummaryReport } = useGeneralSummaryReport(8)
  useUserDisplaytime({ foreign: seminarSelected })

  useEffect(() => {
    dispatch(showSeminar(id))
  }, [id, dispatch])

  useEffect(() => {
    if (seminarSelected !== null) {
      handleViewGeneralSummaryReport(seminarSelected.id)
      setFavoriteState(Boolean(seminarSelected.favoriteId))
    }

    if (seminarSelected !== null && search && searchParams.get('lesson') !== null && searchParams.get('lesson') !== 'null') {
      const searchParams = new URLSearchParams(search)
      const tmpLessonIndex = seminarSelected.lessons.findIndex((lesson: any) => lesson.id === Number(searchParams.get('lesson')))
      dispatch(setViewSeminarLesson(seminarSelected.lessons[tmpLessonIndex]))
      searchParams.delete('lesson')
      navigate(`${pathname}?${searchParams}`, { replace: true })
    } else if (seminarSelected !== null && seminarSelected.lessons.length === 1 && seminarSelected.visibility !== 1) {
      dispatch(setViewSeminarLesson(seminarSelected.lessons[0]))
    }
  }, [seminarSelected])

  const handleFavoriteClick = (seminar_id: number) => (state: boolean) => {
    if (state) {
      dispatch(setFavorite({ id: seminar_id, type: 'seminar' }))
    } else {
      dispatch(unsetFavorite({ id: seminar_id, type: 'seminar' }))
    }
    setFavoriteState(state)
  }

  const hasUserAccess =
    seminarSelected?.visibility === 1 &&
    authUser != null &&
    (authUser.vip_lines.includes(seminarSelected.line_id) ||
      (seminarSelected.line_id === null && authUser.vip_brands.includes(seminarSelected.brand_id)) ||
      [1, 2, 3, 5].includes(authUser.role_id))

  const isAdminUser = authUser !== null && [1, 2].includes(authUser.role_id)

  return {
    seminarSelected,
    seminarlesson_selected,
    showForm,
    showFormSeminarLesson,
    registeredUsers,
    authUser,
    error,
    msg,
    loading,
    open,
    setOpen,
    favoriteState,
    currentTab,
    setCurrentTab,
    handleFavoriteClick,
    handleEditSeminar: () => dispatch(toggleFormSeminar()),
    handleAddSeminarLesson: () => dispatch(toggleFormSeminarLesson()),
    handleBackToSeminarList: setViewSeminarLesson(null),
    hasUserAccess,
    isAdminUser
  }
}
